import BuildingIcon from "@redotech/redo-icons/building-02.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { redoManagedLocationFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isRedoManagedLocationStepValid,
  RedoManagedLocationState,
} from "@redotech/redo-model/return-flow-step-valid";

import { ReturnProcessingLevel } from "@redotech/redo-model/team";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const REDO_MANAGED_LOCATION = (
  Details: React.ComponentType<StepTypeDetailsProps<RedoManagedLocationState>>,
): StepType<RedoManagedLocationState, Step.RedoManagedLocation> => ({
  layout() {
    return BlockLayout.FULL;
  },

  empty: {
    returnsCenterIds: [],
    serviceLevel: ReturnProcessingLevel.VERIFICATION,
    refulfillmentEnabled: false,
  },

  title: "Returns Center",

  customTitle: (state) => state.customTitle,

  description: (state) => {
    const count = state.returnsCenterIds?.length ?? 0;
    if (count === 0) {
      return "No center selected";
    }
    return count === 1 ? "1 center" : `${count} centers`;
  },

  Icon: BuildingIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => redoManagedLocationFromModel(model),

  toModel: (state, _id) => ({
    type: Step.REDO_MANAGED_LOCATION,
    customTitle: state.customTitle,
    returnsCenterIds: state.returnsCenterIds,
    serviceLevel: state.serviceLevel,
    refulfillmentEnabled: state.refulfillmentEnabled,
    processingFee: state.processingFee,
    consolidationScheduleDays: state.consolidationScheduleDays,
  }),

  valid: (state) => isRedoManagedLocationStepValid(state).valid,

  stepDeleted: (state) => state,
});

export { type RedoManagedLocationState } from "@redotech/redo-model/return-flow-step-valid";
